import { SimpleMarkdown } from '@/frontend/components/SimpleMarkdown'
import type { SelectedFile, KnowledgeDefaultFile } from '../types'
import { useFileContent } from './useFileContent'

interface Props {
  file: SelectedFile
  fileContentUrl?: string | null
  preload?: KnowledgeDefaultFile | null
}

export default function MemoriaFilePreview({ file, fileContentUrl, preload }: Props) {
  const preloadEntries = preload ? [preload] : undefined
  const { content, loading, error } = useFileContent(file, fileContentUrl ?? null, preloadEntries)

  return (
    <div>
      <div className="flex items-baseline gap-2 mb-3 pb-3 border-b border-border">
        <span className="text-[14px] font-semibold text-foreground">{file.name}</span>
        {file.path !== file.name && (
          <span className="font-mono text-[11px] text-faint-foreground">{file.path}</span>
        )}
      </div>

      {loading ? (
        <p className="text-[13px] text-muted-foreground italic">Carregando…</p>
      ) : error ? (
        <p className="text-[13px] italic text-destructive">Não foi possível carregar: {error}</p>
      ) : content ? (
        <SimpleMarkdown content={content} />
      ) : (
        <p className="text-sm text-muted-foreground italic">Arquivo vazio</p>
      )}
    </div>
  )
}
